import * as React from 'react';

const CatalogArrowDown = (props) => (
    <svg width={16} height={16} fill="none" {...props}>
        <path stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="m12 6-4 4-4-4" />
    </svg>
);

export default CatalogArrowDown;
